import { render, staticRenderFns } from "./LessonsViewer.vue?vue&type=template&id=916471f2&scoped=true"
import script from "./LessonsViewer.vue?vue&type=script&lang=js"
export * from "./LessonsViewer.vue?vue&type=script&lang=js"
import style0 from "./LessonsViewer.vue?vue&type=style&index=0&id=916471f2&prod&lang=css"
import style1 from "./LessonsViewer.vue?vue&type=style&index=1&id=916471f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "916471f2",
  null
  
)

export default component.exports